/**
 * DASHBOARD-PARTICIPATION-POPULATIONS-SKELETON.WIDGET
 * Skeleton adapté à dashboard-participation-populations.widget.tsx : quelques lignes
 * "nom + barre de progression + pourcentage", même largeur minimale (800px) que le
 * vrai tableau pour éviter tout saut de layout.
 */
import Skeleton from "@/components/skeleton"

export default function DashboardParticipationPopulationsSkeletonWidget() {
  return (
    <div style={{ minWidth: 800 }}>
      <div className="flex" style={{ marginBottom: 24 }}>
        <Skeleton width={120} height={12} />
        <div className="width-40" />
        <Skeleton width={220} height={12} />
      </div>

      {[0, 1, 2, 3, 4].map((i) => (
        <div key={i} className="flex items-center" style={{ height: 40, gap: 16 }}>
          <Skeleton width={140} height={12} />
          <div className="flex2">
            <Skeleton width="100%" height={10} borderRadius={6} />
          </div>
          <Skeleton width={36} height={12} />
        </div>
      ))}
    </div>
  )
}
